export default "__VITE_ASSET__CNQO_yAs__"